<script lang="ts">
  import { currentRoute, onRouteChange } from '$ui/router';
  import { warmUp } from '$ui/app-state.svelte';
  import { markSeen, seenBefore } from '$infra/first-run';
  import UpdateHint from '$ui/components/UpdateHint.svelte';
  import PlacementReoffer from '$ui/components/PlacementReoffer.svelte';
  import Catch from '$ui/routes/Catch.svelte';
  import Today from '$ui/routes/Today.svelte';
  import Onboarding from '$ui/routes/Onboarding.svelte';

  /**
   * The first-run decision, made synchronously — before the first paint, not
   * after it.
   *
   * A brand-new device opens onboarding; every later visit opens the Catch
   * screen. Deciding this from the replayed log would mean deciding it after an
   * IndexedDB round trip, which is exactly the flash-then-jump this replaces:
   * the app would paint the Catch button and then pull it out from under a
   * thumb that was already moving.
   */
  const firstRun = !seenBefore();
  markSeen();

  // Set the hash too, not just the state: the URL should say where you are, and
  // a first-time user who reloads halfway through onboarding should still be in
  // onboarding rather than dropped onto the Catch screen.
  if (firstRun && globalThis.location.hash === '') {
    globalThis.location.hash = '#/onboard';
  }

  let route = $state(currentRoute());

  $effect(() => onRouteChange((next) => (route = next)));

  // Opens the store in the background so it is usually warm when a tap arrives.
  // An optimisation, never a precondition: the Catch button renders and is
  // tappable whether or not this has finished.
  $effect(() => {
    warmUp();
  });


</script>

<UpdateHint />

{#if route === 'catch'}
  <PlacementReoffer />
{/if}

{#if route === 'onboard'}
  <Onboarding />
{:else if route === 'today'}
  <Today />
{:else}
  <Catch />
{/if}
